<template>
  <div>
    <v-dialog scrollable max-width="1000px" v-model="model" persistent>
      <material-card
        :title="
          $t('components.plan_benefit_rules.plan_benefit_dialog.title_{0}', [
            benefitName,
          ])
        "
        :color="$vuetify.theme.themes.light.secondary"
        icon="rules"
      >
        <v-card-text>
          <v-row class="mt-2 mb-0" no-gutters v-if="planBenefit">
            <v-col xs="12" sm="6" md="6" lg="4">
              {{
                $t(
                  "components.plan_benefit_rules.plan_benefit_dialog.requires_referral"
                )
              }}
              <br />
              <span class="minfo">
                {{
                  planBenefit.RequiresReferral
                    ? $t("globals.yes")
                    : $t("globals.no")
                }}
              </span>
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="4">
              {{
                $t(
                  "components.plan_benefit_rules.plan_benefit_dialog.requires_letter"
                )
              }}
              <br />
              <span class="minfo">
                {{
                  planBenefit.RequiresLetter
                    ? $t("globals.yes")
                    : $t("globals.no")
                }}
              </span>
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="4">
              {{
                $t(
                  "components.plan_benefit_rules.plan_benefit_dialog.available_for"
                )
              }}
              <br />
              <span class="minfo">
                {{ getAvailableFor() }}
              </span>
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="4">
              {{
                $t(
                  "components.plan_benefit_rules.plan_benefit_dialog.audit_rule"
                )
              }}
              <br />
              <span class="minfo">
                {{ formatRule(planBenefit.AuditRule) }}
              </span>
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="4">
              {{
                $t(
                  "components.plan_benefit_rules.plan_benefit_dialog.supervisor_audit_rule"
                )
              }}
              <br />
              <span class="minfo">
                {{ formatRule(planBenefit.SupervisorAuditRule) }}
              </span>
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="4">
              {{
                $t(
                  "components.plan_benefit_rules.plan_benefit_dialog.benefit_rules"
                )
              }}
              <br />
              <span
                class="minfo"
                v-for="(rule, index) in planBenefit.BenefitRules"
                :key="index"
              >
                {{ formatRule(rule) }}
                <br />
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog v-model="loading" scrollable max-width="100px" persistent>
      <v-container fluid grid-list-md>
        <v-layout v-if="loading" row justify-center>
          <v-flex xs12 sm6 md4 lg3>
            <v-progress-circular indeterminate></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
    <error-handler :error="error" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../ErrorHandler.vue";
export default {
  props: ["model", "effectiveDate", "planIdentityId", "id", "benefitName", "memberGroupIdentityId"],
  components: {
    ErrorHandler,
  },
  data() {
    return {
      planBenefit: null,
      error: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["language"]),
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          console.log("load data");
          this.loadData();
        }
      },
    },
  },
  methods: {
    ...mapActions("claims", ["getPlanBenefitByEffectiveDate"]),
    async loadData() {
      this.loading = true;
      try {
        this.planBenefit = (await this.getPlanBenefitByEffectiveDate({
          memberGroupIdentityId: this.memberGroupIdentityId,
          effectiveDate: this.effectiveDate,
          id: this.id,
        })).data.value[0];
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    getAvailableFor() {
      if (this.planBenefit.AdminOnly) {
        if (this.planBenefit.MemberOnly) {
          return this.$t(
            "globals.all"
          );
        }
        return this.$t(
          "components.plan_benefit_rules.plan_benefit_dialog.admin_only"
        );
      }
      if (this.planBenefit.MemberOnly) {
        return this.$t(
          "components.plan_benefit_rules.plan_benefit_dialog.member_only"
        );
      }
      return this.$t("globals.all");
    },
    formatRule(rule) {
      if (rule === null || rule === undefined) {
        return;
      }
      console.log(rule);
      let params = [];
      if (rule.JsonParams !== "") {
        params = JSON.parse(rule.JsonParams);
      }
      console.log(params);
      return (
        rule.Check +
        " (" +
        Object.keys(params)
          .map((o) => `${o}: ${params[o]}`)
          .join(", ") +
        ")"
      );
    },
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
<style></style>
